import { Expose } from "class-transformer";
import { OnboardingFormDraft } from "@/core/features/employee-onboarding/onboarding-form-draft.interface";

export class SaveOnboardingFormDto {
  @Expose()
  formDraft: OnboardingFormDraft;
}
